import Reveal from "@/components/base/Reveal";
import { quickEntries } from "@/mocks/home";

export default function EntryBar() {
  return (
    <section className="relative z-10 mx-auto -mt-14 w-full max-w-[1400px] px-4 md:-mt-20 md:px-8">
      <Reveal>
        <div className="rounded-lg border border-background-200 bg-background-50/95 p-3 backdrop-blur md:p-4">
          <div className="mb-3 flex items-center justify-between gap-3 px-1 md:px-2">
            <div className="flex items-center gap-2">
              <i className="ri-links-line text-primary-600" />
              <h2 className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                材料入口 · 按类型直达
              </h2>
            </div>
            <span className="hidden text-xs text-secondary-500 sm:block">
              全部材料已去重、校对时间戳
            </span>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {quickEntries.map((entry) => (
              <a
                key={entry.title}
                href={entry.href}
                className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3.5 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={entry.icon} />
                </span>
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="flex items-center justify-between gap-2">
                    <span className="font-heading text-sm font-semibold text-foreground-950">
                      {entry.title}
                    </span>
                    <span className="text-xs font-medium text-primary-600">
                      {entry.count}
                    </span>
                  </span>
                  <span className="mt-0.5 truncate text-xs text-secondary-500">
                    {entry.desc}
                  </span>
                </span>
                <i className="ri-arrow-right-s-line text-lg text-secondary-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
              </a>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
}